import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Company } from 'src/app/interfaces/company.interface';
import { CompanyService } from 'src/app/services/company.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-edit-company-top-bar',
  templateUrl: './edit-company-top-bar.component.html',
  styleUrls: ['./edit-company-top-bar.component.scss']
})
export class EditCompanyTopBarComponent implements OnInit, OnDestroy {

  // params
  id: number;

  // data
  company: Company;

  // subscriptions
  private _companySub: Subscription;

  constructor(
    private _companySvc: CompanyService,
    private _route: ActivatedRoute
  ) { }

  ngOnInit(): void {

    this._route.params.subscribe((params: any) => {
      this.id = Number(params.id);
      this._companySvc.getCompany(this.id);
    });

    this._companySub = this._companySvc.Company.subscribe((res: Company) => {
      if (res && res.Id === this.id) {
        this.company = res;
      }
    });

  }

  ngOnDestroy(): void {
    this._companySub.unsubscribe();
  }

}
